<script>
    import "./socialNetwork.css"
    import Input from "../input-design/Input.svelte";
    export let mediaUrls, errors;
</script>

<ul class="social-networks list-none form-row">
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_facebook.svg" alt="facebook">
            <Input placeholder="www.facebook.com/polinate"
                   bind:value={mediaUrls.facebook}
                   on:input={() => (errors = { ...errors, facebook: "" })}
                   error={errors.facebook} id="p-facebook"/>
        </span>
        <div class="error">{errors.facebook}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_twitter.svg" alt="twitter">
            <Input bind:value={mediaUrls.twitter} placeholder="www.twitter.com/polinate"
                   on:input={() => (errors = { ...errors, twitter: "" })}
                   error={errors.twitter} id="p-twitter"/>
        </span>
        <div class="error">{errors.twitter}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_linkedin.svg" alt="linkedin">
            <Input placeholder="www.linkedin.com/polinate"
                   bind:value={mediaUrls.linkedin}
                   on:input={() => (errors = { ...errors, linkedin: "" })}
                   error={errors.linkedin} id="p-linkedin"/>
        </span>
        <div class="error">{errors.linkedin}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_instagram.svg" alt="instagram">
            <Input placeholder="www.instagram.com/polinate"
                   bind:value={mediaUrls.instagram}
                   on:input={() => (errors = { ...errors, instagram: "" })}
                   error={errors.instagram} id="p-instagram"/>
        </span>
        <div class="error">{errors.instagram}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_telegram.svg" alt="telegram">
            <Input placeholder="www.telegram.com/polinate"
                   bind:value={mediaUrls.telegram}
                   on:input={() => (errors = { ...errors, telegram: "" })}
                   error={errors.telegram} id="p-telegram"/>
        </span>
        <div class="error">{errors.telegram}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_youtube.svg" alt="youtube">
            <Input placeholder="www.youtube.com/polinate"
                   bind:value={mediaUrls.youtube}
                   on:input={() => (errors = { ...errors, youtube: "" })}
                   error={errors.youtube} id="p-youtube"/>
        </span>
        <div class="error">{errors.youtube}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_twitch.svg" alt="twitch">
            <Input placeholder="www.twitch.com/polinate"
                   bind:value={mediaUrls.twitch}
                   on:input={() => (errors = { ...errors, twitch: "" })}
                   error={errors.twitch} id="p-twitch"/>
        </span>
        <div class="error">{errors.twitch}</div>
    </li>
    <li class="col-6">
        <span class="relative">
            <img src="./images/ic_discord.svg" alt="discord">
            <Input placeholder="www.discord.com/polinate"
                   bind:value={mediaUrls.discord}
                   on:input={() => (errors = { ...errors, discord: "" })}
                   error={errors.discord} id="p-discord"/>
        </span>
        <div class="error">{errors.discord}</div>
    </li>
</ul>